<div class="copyright">
    &copy;
    {{test | date: 'yyyy'}} Brevity Softwares            
</div>